import { Codebook } from '../Codebook'
import { Country } from '../country/Country'
import { CountryId } from '../country/CountryId'
import { SalesAreaId } from './SalesAreaId'

export class SalesArea extends Codebook<SalesAreaId> {
  private constructor(
    public readonly id: SalesAreaId,
    public readonly name: () => string,
    public readonly country: Country,
  ) {
    super(id)
  }

  // Czech Republic
  static readonly CZE_PRAGUE = new SalesArea(
    SalesAreaId.CZE_PRAGUE,
    () => 'Hlavní město Praha',
    Country.CZE,
  )
  static readonly CZE_KARLOVY_VARY = new SalesArea(
    SalesAreaId.CZE_KARLOVY_VARY,
    () => 'Karlovarský kraj',
    Country.CZE,
  )
  static readonly CZE_CENTRAL_BOHEMIA = new SalesArea(
    SalesAreaId.CZE_CENTRAL_BOHEMIA,
    () => 'Středočeský kraj',
    Country.CZE,
  )
  static readonly CZE_VYSOCINA = new SalesArea(
    SalesAreaId.CZE_VYSOCINA,
    () => 'Kraj Vysočina',
    Country.CZE,
  )
  static readonly CZE_OLOMOUC = new SalesArea(
    SalesAreaId.CZE_OLOMOUC,
    () => 'Olomoucký kraj',
    Country.CZE,
  )
  static readonly CZE_MORAVIA_SILESIA = new SalesArea(
    SalesAreaId.CZE_MORAVIA_SILESIA,
    () => 'Moravskoslezský kraj',
    Country.CZE,
  )
  static readonly CZE_SOUTH_BOHEMIA = new SalesArea(
    SalesAreaId.CZE_SOUTH_BOHEMIA,
    () => 'Jihočeský kraj',
    Country.CZE,
  )
  static readonly CZE_PLZEN = new SalesArea(
    SalesAreaId.CZE_PLZEN,
    () => 'Plzeňský kraj',
    Country.CZE,
  )
  static readonly CZE_ZLIN = new SalesArea(SalesAreaId.CZE_ZLIN, () => 'Zlínský kraj', Country.CZE)
  static readonly CZE_SOUTH_MORAVIA = new SalesArea(
    SalesAreaId.CZE_SOUTH_MORAVIA,
    () => 'Jihomoravský kraj',
    Country.CZE,
  )
  static readonly CZE_PARDUBICE = new SalesArea(
    SalesAreaId.CZE_PARDUBICE,
    () => 'Pardubický kraj',
    Country.CZE,
  )
  static readonly CZE_HRADEC_KRALOVE = new SalesArea(
    SalesAreaId.CZE_HRADEC_KRALOVE,
    () => 'Královéhradecký kraj',
    Country.CZE,
  )
  static readonly CZE_USTI = new SalesArea(SalesAreaId.CZE_USTI, () => 'Ústecký kraj', Country.CZE)
  static readonly CZE_LIBEREC = new SalesArea(
    SalesAreaId.CZE_LIBEREC,
    () => 'Liberecký kraj',
    Country.CZE,
  )

  // Slovakia
  static readonly SVK_BRATISLAVA = new SalesArea(
    SalesAreaId.SVK_BRATISLAVA,
    () => 'Bratislavský kraj',
    Country.SVK,
  )
  static readonly SVK_TRNAVA = new SalesArea(
    SalesAreaId.SVK_TRNAVA,
    () => 'Trnavský kraj',
    Country.SVK,
  )
  static readonly SVK_TRENCIN = new SalesArea(
    SalesAreaId.SVK_TRENCIN,
    () => 'Trenčiansky kraj',
    Country.SVK,
  )
  static readonly SVK_NITRA = new SalesArea(
    SalesAreaId.SVK_NITRA,
    () => 'Nitriansky kraj',
    Country.SVK,
  )
  static readonly SVK_ZILINA = new SalesArea(
    SalesAreaId.SVK_ZILINA,
    () => 'Žilinský kraj',
    Country.SVK,
  )
  static readonly SVK_BANSKA_BYSTRICA = new SalesArea(
    SalesAreaId.SVK_BANSKA_BYSTRICA,
    () => 'Banskobystrický kraj',
    Country.SVK,
  )
  static readonly SVK_PRESOV = new SalesArea(
    SalesAreaId.SVK_PRESOV,
    () => 'Prešovský kraj',
    Country.SVK,
  )
  static readonly SVK_KOSICE = new SalesArea(
    SalesAreaId.SVK_KOSICE,
    () => 'Košický kraj',
    Country.SVK,
  )

  // Poland
  static readonly POL_DOLNOSLASKIE = new SalesArea(
    SalesAreaId.POL_DOLNOSLASKIE,
    () => 'województwo dolnośląskie',
    Country.POL,
  )
  static readonly POL_KUJAWSKO_POMORSKIE = new SalesArea(
    SalesAreaId.POL_KUJAWSKO_POMORSKIE,
    () => 'województwo kujawsko-pomorskie',
    Country.POL,
  )
  static readonly POL_LODZKIE = new SalesArea(
    SalesAreaId.POL_LODZKIE,
    () => 'województwo łódzkie',
    Country.POL,
  )
  static readonly POL_LUBELSKIE = new SalesArea(
    SalesAreaId.POL_LUBELSKIE,
    () => 'województwo lubelskie',
    Country.POL,
  )
  static readonly POL_LUBUSKIE = new SalesArea(
    SalesAreaId.POL_LUBUSKIE,
    () => 'województwo lubuskie',
    Country.POL,
  )
  static readonly POL_MALOPOLSKIE = new SalesArea(
    SalesAreaId.POL_MALOPOLSKIE,
    () => 'województwo małopolskie',
    Country.POL,
  )
  static readonly POL_MAZOWIECKIE = new SalesArea(
    SalesAreaId.POL_MAZOWIECKIE,
    () => 'województwo mazowieckie',
    Country.POL,
  )
  static readonly POL_OPOLSKIE = new SalesArea(
    SalesAreaId.POL_OPOLSKIE,
    () => 'województwo opolskie',
    Country.POL,
  )
  static readonly POL_PODKARPACKIE = new SalesArea(
    SalesAreaId.POL_PODKARPACKIE,
    () => 'województwo podkarpackie',
    Country.POL,
  )
  static readonly POL_PODLASKIE = new SalesArea(
    SalesAreaId.POL_PODLASKIE,
    () => 'województwo podlaskie',
    Country.POL,
  )
  static readonly POL_POMORSKIE = new SalesArea(
    SalesAreaId.POL_POMORSKIE,
    () => 'województwo pomorskie',
    Country.POL,
  )
  static readonly POL_SLASKIE = new SalesArea(
    SalesAreaId.POL_SLASKIE,
    () => 'województwo śląskie',
    Country.POL,
  )
  static readonly POL_SWIETOKRZYSKIE = new SalesArea(
    SalesAreaId.POL_SWIETOKRZYSKIE,
    () => 'województwo świętokrzyskie',
    Country.POL,
  )
  static readonly POL_WARMINSKO_MAZURSKIE = new SalesArea(
    SalesAreaId.POL_WARMINSKO_MAZURSKIE,
    () => 'województwo warmińsko-mazurskie',
    Country.POL,
  )
  static readonly POL_WIELKOPOLSKIE = new SalesArea(
    SalesAreaId.POL_WIELKOPOLSKIE,
    () => 'województwo wielkopolskie',
    Country.POL,
  )
  static readonly POL_ZACHODNIOPOMORSKIE = new SalesArea(
    SalesAreaId.POL_ZACHODNIOPOMORSKIE,
    () => 'województwo zachodniopomorskie',
    Country.POL,
  )

  // Hungary
  static readonly HUN_BACS_KISKUN = new SalesArea(
    SalesAreaId.HUN_BACS_KISKUN,
    () => 'Bács-Kiskun vármegye',
    Country.HUN,
  )
  static readonly HUN_BARANYA = new SalesArea(
    SalesAreaId.HUN_BARANYA,
    () => 'Baranya vármegye',
    Country.HUN,
  )
  static readonly HUN_BEKES = new SalesArea(
    SalesAreaId.HUN_BEKES,
    () => 'Békés vármegye',
    Country.HUN,
  )
  static readonly HUN_BORSOD_ABAUJ_ZEMPLEN = new SalesArea(
    SalesAreaId.HUN_BORSOD_ABAUJ_ZEMPLEN,
    () => 'Borsod-Abaúj-Zemplén vármegye',
    Country.HUN,
  )
  static readonly HUN_BUDAPEST = new SalesArea(
    SalesAreaId.HUN_BUDAPEST,
    () => 'Budapest',
    Country.HUN,
  )
  static readonly HUN_CSONGRAD_CSANAD = new SalesArea(
    SalesAreaId.HUN_CSONGRAD_CSANAD,
    () => 'Csongrád-Csanád vármegye',
    Country.HUN,
  )
  static readonly HUN_FEJER = new SalesArea(
    SalesAreaId.HUN_FEJER,
    () => 'Fejér vármegye',
    Country.HUN,
  )
  static readonly HUN_GYOR_MOSON_SOPRON = new SalesArea(
    SalesAreaId.HUN_GYOR_MOSON_SOPRON,
    () => 'Győr-Moson-Sopron vármegye',
    Country.HUN,
  )
  static readonly HUN_HAJDU_BIHAR = new SalesArea(
    SalesAreaId.HUN_HAJDU_BIHAR,
    () => 'Hajdú-Bihar vármegye',
    Country.HUN,
  )
  static readonly HUN_HEVES = new SalesArea(
    SalesAreaId.HUN_HEVES,
    () => 'Heves vármegye',
    Country.HUN,
  )
  static readonly HUN_JASZ_NAGYKUN_SZOLNOK = new SalesArea(
    SalesAreaId.HUN_JASZ_NAGYKUN_SZOLNOK,
    () => 'Jász-Nagykun-Szolnok vármegye',
    Country.HUN,
  )
  static readonly HUN_KOMAROM_ESZTERGOM = new SalesArea(
    SalesAreaId.HUN_KOMAROM_ESZTERGOM,
    () => 'Komárom-Esztergom vármegye',
    Country.HUN,
  )
  static readonly HUN_NOGRAD = new SalesArea(
    SalesAreaId.HUN_NOGRAD,
    () => 'Nógrád vármegye',
    Country.HUN,
  )
  static readonly HUN_PEST = new SalesArea(SalesAreaId.HUN_PEST, () => 'Pest vármegye', Country.HUN)
  static readonly HUN_SOMOGY = new SalesArea(
    SalesAreaId.HUN_SOMOGY,
    () => 'Somogy vármegye',
    Country.HUN,
  )
  static readonly HUN_SZABOLCS_SZATMAR_BEREG = new SalesArea(
    SalesAreaId.HUN_SZABOLCS_SZATMAR_BEREG,
    () => 'Szabolcs-Szatmár-Bereg vármegye',
    Country.HUN,
  )
  static readonly HUN_TOLNA = new SalesArea(
    SalesAreaId.HUN_TOLNA,
    () => 'Tolna vármegye',
    Country.HUN,
  )
  static readonly HUN_VAS = new SalesArea(SalesAreaId.HUN_VAS, () => 'Vas vármegye', Country.HUN)
  static readonly HUN_VESZPREM = new SalesArea(
    SalesAreaId.HUN_VESZPREM,
    () => 'Veszprém vármegye',
    Country.HUN,
  )
  static readonly HUN_ZALA = new SalesArea(SalesAreaId.HUN_ZALA, () => 'Zala vármegye', Country.HUN)

  // Romania
  static readonly ROU_AB = new SalesArea(SalesAreaId.ROU_AB, () => 'județul Alba', Country.ROU)
  static readonly ROU_AR = new SalesArea(SalesAreaId.ROU_AR, () => 'județul Arad', Country.ROU)
  static readonly ROU_AG = new SalesArea(SalesAreaId.ROU_AG, () => 'județul Argeș', Country.ROU)
  static readonly ROU_BC = new SalesArea(SalesAreaId.ROU_BC, () => 'județul Bacău', Country.ROU)
  static readonly ROU_BH = new SalesArea(SalesAreaId.ROU_BH, () => 'județul Bihor', Country.ROU)
  static readonly ROU_BN = new SalesArea(
    SalesAreaId.ROU_BN,
    () => 'județul Bistrița-Năsăud',
    Country.ROU,
  )
  static readonly ROU_BT = new SalesArea(SalesAreaId.ROU_BT, () => 'județul Botoșani', Country.ROU)
  static readonly ROU_BV = new SalesArea(SalesAreaId.ROU_BV, () => 'județul Brașov', Country.ROU)
  static readonly ROU_BR = new SalesArea(SalesAreaId.ROU_BR, () => 'județul Brăila', Country.ROU)
  static readonly ROU_BZ = new SalesArea(SalesAreaId.ROU_BZ, () => 'județul Buzău', Country.ROU)
  static readonly ROU_CS = new SalesArea(
    SalesAreaId.ROU_CS,
    () => 'județul Caraș-Severin',
    Country.ROU,
  )
  static readonly ROU_CL = new SalesArea(SalesAreaId.ROU_CL, () => 'județul Călărași', Country.ROU)
  static readonly ROU_CJ = new SalesArea(SalesAreaId.ROU_CJ, () => 'județul Cluj', Country.ROU)
  static readonly ROU_CT = new SalesArea(SalesAreaId.ROU_CT, () => 'județul Constanța', Country.ROU)
  static readonly ROU_CV = new SalesArea(SalesAreaId.ROU_CV, () => 'județul Covasna', Country.ROU)
  static readonly ROU_DB = new SalesArea(SalesAreaId.ROU_DB, () => 'județul Dâmbovița', Country.ROU)
  static readonly ROU_DJ = new SalesArea(SalesAreaId.ROU_DJ, () => 'județul Dolj', Country.ROU)
  static readonly ROU_GL = new SalesArea(SalesAreaId.ROU_GL, () => 'județul Galați', Country.ROU)
  static readonly ROU_GR = new SalesArea(SalesAreaId.ROU_GR, () => 'județul Giurgiu', Country.ROU)
  static readonly ROU_GJ = new SalesArea(SalesAreaId.ROU_GJ, () => 'județul Gorj', Country.ROU)
  static readonly ROU_HR = new SalesArea(SalesAreaId.ROU_HR, () => 'județul Harghita', Country.ROU)
  static readonly ROU_HD = new SalesArea(SalesAreaId.ROU_HD, () => 'județul Hunedoara', Country.ROU)
  static readonly ROU_IL = new SalesArea(SalesAreaId.ROU_IL, () => 'județul Ialomița', Country.ROU)
  static readonly ROU_IS = new SalesArea(SalesAreaId.ROU_IS, () => 'județul Iași', Country.ROU)
  static readonly ROU_IF = new SalesArea(SalesAreaId.ROU_IF, () => 'județul Ilfov', Country.ROU)
  static readonly ROU_MM = new SalesArea(SalesAreaId.ROU_MM, () => 'județul Maramureș', Country.ROU)
  static readonly ROU_MH = new SalesArea(SalesAreaId.ROU_MH, () => 'județul Mehedinți', Country.ROU)
  static readonly ROU_MS = new SalesArea(SalesAreaId.ROU_MS, () => 'județul Mureș', Country.ROU)
  static readonly ROU_NT = new SalesArea(SalesAreaId.ROU_NT, () => 'județul Neamț', Country.ROU)
  static readonly ROU_OT = new SalesArea(SalesAreaId.ROU_OT, () => 'județul Olt', Country.ROU)
  static readonly ROU_PH = new SalesArea(SalesAreaId.ROU_PH, () => 'județul Prahova', Country.ROU)
  static readonly ROU_SM = new SalesArea(SalesAreaId.ROU_SM, () => 'județul Satu Mare', Country.ROU)
  static readonly ROU_SJ = new SalesArea(SalesAreaId.ROU_SJ, () => 'județul Sălaj', Country.ROU)
  static readonly ROU_SB = new SalesArea(SalesAreaId.ROU_SB, () => 'județul Sibiu', Country.ROU)
  static readonly ROU_SV = new SalesArea(SalesAreaId.ROU_SV, () => 'județul Suceava', Country.ROU)
  static readonly ROU_TR = new SalesArea(SalesAreaId.ROU_TR, () => 'județul Teleorman', Country.ROU)
  static readonly ROU_TM = new SalesArea(SalesAreaId.ROU_TM, () => 'județul Timiș', Country.ROU)
  static readonly ROU_TL = new SalesArea(SalesAreaId.ROU_TL, () => 'județul Tulcea', Country.ROU)
  static readonly ROU_VS = new SalesArea(SalesAreaId.ROU_VS, () => 'județul Vaslui', Country.ROU)
  static readonly ROU_VL = new SalesArea(SalesAreaId.ROU_VL, () => 'județul Vâlcea', Country.ROU)
  static readonly ROU_VN = new SalesArea(SalesAreaId.ROU_VN, () => 'județul Vrancea', Country.ROU)
  static readonly ROU_B = new SalesArea(
    SalesAreaId.ROU_B,
    () => 'Municipiul București',
    Country.ROU,
  )

  static getByCountryId = (countryId: CountryId): SalesArea[] => {
    return SalesArea.all().filter((area) => area.country.id === countryId)
  }
}
